interface IPageItemWrapperProps {
    children: React.ReactNode;
    classList: string[];
}

export interface IPageItemattributes {
    'aria-label'?: string;
    'aria-disabled'?: boolean;
}

const PageItemWrapper: React.FC<IPageItemWrapperProps> = ({ children, classList, ...attributes }) => {
    const classNames = ['page-item'].concat(classList).join(' ');
    return <div {...attributes} className={classNames}>
        {children}
    </div>
}

export default PageItemWrapper;
